import { createSlice } from "@reduxjs/toolkit";
import { badgeStatisticsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const badgeStatisticsSlice = createSlice({
  name: "badgeStatistics",
  initialState: data,
  reducers: {
    badgeStatisticsSlice(state) {
      state.isLoading = false;
    },
    badgeStatisticsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    badgeStatisticsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    badgeStatisticsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const badgeStatisticsHandler = () => async (dispatch: any) => {
  try {
    dispatch(badgeStatisticsAction.badgeStatisticsSlice());
    const response: any = await badgeStatisticsAPI();
    dispatch(badgeStatisticsAction.badgeStatisticsSliceSuccess(response));
  } catch (e: any) {
    dispatch(badgeStatisticsAction.badgeStatisticsSliceFailure(e?.response?.data?.message));
    dispatch(badgeStatisticsAction.badgeStatisticsSliceReset());
  }
};
export default badgeStatisticsSlice.reducer;
export const badgeStatisticsAction = badgeStatisticsSlice.actions;
